
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 13.1 15.6"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Layer_2","data-name":"Layer 2"}},[_c('g',{attrs:{"id":"Layer_1-2","data-name":"Layer 1"}},[_c('path',{staticClass:"cls-1",attrs:{"d":"M11.33 15.6H1.76A1.76 1.76 0 0 1 0 13.83V1.76A1.76 1.76 0 0 1 1.76 0h6.85a1.15 1.15 0 0 1 .82.34l3.33 3.32a1.19 1.19 0 0 1 .34.82v9.35a1.77 1.77 0 0 1-1.77 1.77zM1.76 1.09a.67.67 0 0 0-.67.67v12.07a.68.68 0 0 0 .67.68h9.57a.68.68 0 0 0 .67-.68V4.48L8.66 1.11h-.05z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M8.07 5a2.27 2.27 0 0 0 1.61.66H12V4.52H9.68A1.2 1.2 0 0 1 8.5 3.33V1.09H7.4v2.24A2.29 2.29 0 0 0 8.07 5z"}}),_c('path',{staticClass:"cls-1",attrs:{"transform":"rotate(-74.06 6.477 9.17)","d":"M2.63 8.62h7.7v1.09h-7.7z"}}),_c('path',{staticClass:"cls-1",attrs:{"d":"M8.62 11.13l-.66-.87L9.49 9.1 7.95 7.89l.68-.86 2.65 2.08-2.66 2.02zM4.47 11.13L1.82 9.11l2.65-2.08.67.86L3.61 9.1l1.53 1.16-.67.87z"}})])])])
          )
        }
      }
    